module.exports = __webpack_public_path__ + "img/head.cd9ee24b.jpg";